import React, { FunctionComponent } from 'react'
import MediaDrawer from '../MediaDrawer'
import MediaCarousel from '../MediaCarousel'
import { SpotlightDrawerProps } from './types'
import { IconType } from '@bt-react/components/Icon'
import PresenterCard from '../PresenterCard'
import { mediaType as MediaType } from '@bt-react/constants'

const SpotlightDrawer: FunctionComponent<SpotlightDrawerProps> = props => {

  const presenterList = () => {

    if (props.presenterDetails.length === 0) return []

    const spotlightCards: React.JSX.Element[]  = []

    const allPresentersCard = <PresenterCard
      dataBdd={`spotlight-presenter-card-all-presenters`}
      onClick={props.onAllPresentersClick}
      firstName={'All'}
      lastName={'presenters'}
      presenterSpotlighted={props.mediaType === MediaType.WEBCAM}
      iconName={IconType.iconName.th}
    />

    const autoSpotlightCard =
      <PresenterCard
        dataBdd={`spotlight-presenter-card-autoSpotlight`}
        onClick={props.onAutoSpotlightClick}
        firstName={'Auto'}
        lastName={'spotlight'}
        presenterSpotlighted={props.autoSpotlight && props.mediaType === MediaType.SPOTLIGHT}
        iconName={IconType.iconName.usersClass}
      />

    const presenterCards = props.presenterDetails.map(
      currentPresenters => {

        return <PresenterCard
          dataBdd={`spotlight-presenter-card`}
          onClick={() => props.onPresenterClick(currentPresenters?.id)}
          firstName={currentPresenters?.firstName}
          lastName={currentPresenters?.lastName}
          presenterSpotlighted={
            props.mediaType === MediaType.SPOTLIGHT &&
            typeof currentPresenters !== 'undefined' &&
            props.focusedOnPresenterId === currentPresenters?.id &&
            !props.autoSpotlight
          }
          iconName={IconType.iconName.user}
        />
      }
    )

    if (props.presenterDetails.length > 2) return spotlightCards.concat(allPresentersCard, autoSpotlightCard, presenterCards)

    return props.presenterDetails.length > 1 ? spotlightCards.concat(allPresentersCard, presenterCards) : spotlightCards.concat(presenterCards)
  }

  const getSelected = () => {

    if (props.presenterDetails.length < 2 && props.mediaType !== MediaType.SPOTLIGHT) return -1
    if (props.mediaType !== MediaType.SPOTLIGHT) return 0
    if (props.presenterDetails.length > 2 && props.autoSpotlight) return 1

    const selectedPresenterIndex = props.presenterDetails.findIndex(presenter =>
      typeof presenter !== 'undefined' && props.focusedOnPresenterId === presenter?.id)

    // the first entry in the presenterList will be All Presenters if there is more than 1 presenters
    // the first two entries will be All Presenters and autoSpotlight if there are more than 2 presenters
    return props.presenterDetails.length > 2 ? selectedPresenterIndex + 2 : selectedPresenterIndex + 1

  }

  return (
    <MediaDrawer
      title='Presenters'
      onClick={props.onClick}
      dataBdd='spotlight'
      hidden={props.hidden}
    >
      <MediaCarousel
        items={presenterList()}
        empty={{
          icon: IconType.iconName.thLarge,
          message: 'No presenters'
        }}
        selected={getSelected()}
      />
    </MediaDrawer>
  )
}

export default SpotlightDrawer